<template>
  <div>
    <Header>
      <template #actions>
        <div class="iqos-tooltip-helper-box mr-8">
          <BaseButton
            variant="primary"
            bold
            color="orange-4"
            icon="qr-code"
            @click="show_test_qr_code = !show_test_qr_code"
            size="md"
          >
            {{ $t("inside.test_button") }}
          </BaseButton>

          <IQOSTooltip
            :title="$t('inside.test_button')"
            :qrLink="testOrderLink"
            @close="show_test_qr_code = false"
            v-if="show_test_qr_code"
          >
            {{ $t("inside.test_tooltip") }}
          </IQOSTooltip>
        </div>
        <BaseButton
          @click="$router.push({
            name: 'subscription_history',
            query: {
              from: 'reserve'
            }
          })"
          color="v1-grey-10"
          variant="secondary"
          size="md"
          >{{ $t("tables.payments_history") }}</BaseButton
        >
      </template>
    </Header>

    <PageContainer>
      <!-- <StoreCard :mode="isProUser ? 'pro' : 'reserve'"/> -->
      <SystemCard mode="reserve"/>

      <div class="qrw-heading-md mb-24 mt-40" :class="{
        'system-settings-disabled': !isEnabled
      }">
        {{ $t("mode_settings.required") }}
      </div>

      <HallsAndTables :in_attachment="true" :in_reserve="true" />

      <div class="iqos-grid mt-24">
        <div class="iqos-column">
          <SystemMotdPanel :mode="'reserve'" />
        </div>
        <div class="iqos-column">

        </div>
      </div>

      <div class="qrw-heading-md mb-24 mt-40 v1-grey-6-color" :class="{
        'system-settings-disabled': !isEnabled
      }">
        {{ $t("mode_settings.optional") }}
      </div>

      <div class="iqos-grid">
        <div class="iqos-column">
          <ReserveAllowToday />
        </div>
        <div class="iqos-column">
          <ReservationPricePanel v-if="isOnlineAvailable" />
          <!-- <ReservePayReceiver /> -->
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<style scoped>
.w-inherit {
  width: inherit;
}

.iqos-wrapper {
  display: flex;
  flex-flow: column wrap;
  height: 90vh;
  width: fit-content;
}

.h-100 {
  height: 100vh !important;
}

h2 {
  font-size: 4vh;
}

.settings-header {
  background: #464646;
  height: 10%;
  justify-content: space-between;
  overflow: auto;
  padding: 5.6vh 5.6vh 0 40.6vh;
  display: flex;
  color: white;
  width: 100%;
  float: right;
  position: relative;
}
</style>

<script>
import ReservationPricePanel from "@/components/reserve/ReservationPricePanel.vue";
import ReservePayReceiver from "@/components/reserve/ReservePayReceiver.vue";
import ReserveMaxGuests from "@/components/reserve/ReserveMaxGuests.vue";
import ReserveMaxDays from "@/components/reserve/ReserveMaxDays.vue";
import ReserveAllowToday from "@/components/reserve/ReserveAllowToday.vue";
import HallsAndTables from "@/components/halls/HallsAndTables.vue";
import ReservePolicy from "@/components/reserve/ReservePolicy.vue";
import SystemProgressBar from "@/components/SystemProgressBar.vue";
import SystemMotdPanel from "@/components/SystemMotdPanel.vue";
import StoreCard from "@/components/subscriptions/StoreCard.vue";
import SystemCard from "@/components/subscriptions/SystemCard.vue"

import DemoQRCodePanel from "@/components/DemoQRCodePanel.vue";

export default {
  data() {
    return {
      show_test_qr_code: false
    };
  },
  computed: {
    isOnlineAvailable() {
      return true;
    },
    readyReserve() {
      const from_store = Object.assign({}, this.$store.getters.readyReserve);

      delete from_store.total;
      delete from_store.subtotal;

      return from_store;
    },
    testOrderLink() {
      return this.$store.getters.onlineMenuLink('delivery');
    },
    isProUser() {
      return this.$store.getters['subscriptions/isProUser'];
    },
    isEnabled() {
      return this.cafe.modes.reserve;
    },
    cafe() {
      return this.$store.state.cafe;
    },
  },
  components: {
    ReservationPricePanel,
    ReservePayReceiver,
    ReserveMaxGuests,
    ReserveMaxDays,
    ReserveAllowToday,
    HallsAndTables,
    ReservePolicy,
    SystemProgressBar,
    SystemMotdPanel,
    DemoQRCodePanel,
    StoreCard,
    SystemCard
  },
  created() {
    if (this.cafe.reserve.use_superapp) {
      this.$router.push('/reserve_new');
    }
  }
};
</script>
